import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Store } from '@ngrx/store';
import * as user from '../../../auth/actions/user';
import { TranslateService } from '@ngx-translate/core';

export interface Language {
  code: string,
  name: string
}

@Component({
  selector: 'app-language-picker',
  templateUrl: './language-picker.component.html',
  styleUrls: ['./language-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LanguagePickerComponent implements OnInit {
  @Input() languages: string[] = []
  @Output() onSelectLanguage = new EventEmitter()

  supportedLanguages: Language[]
  selectedLanguage: Language

  constructor(private elemRef: ElementRef,
              private store: Store<any>,
              private translate: TranslateService) { }

  ngOnInit() {
    this.supportedLanguages = this.languages
      .map(langCode => ({code: langCode, name: `lang.${langCode}` }))
    this.selectedLanguage = this.supportedLanguages.find(lang => (lang && lang.code) === this.translate.currentLang)
    this.translate.onLangChange
      .subscribe(lang => this.selectedLanguage = this.supportedLanguages.find(item => (item && item.code) === (lang && lang.lang)))
  }

  selectLanguage(language: Language) {
    this.selectedLanguage = language
    this.store.dispatch(new user.SetLanguage(language && language.code))
    this.onSelectLanguage.emit()
  }

}
